import { css } from "styled-components";
import { Colors } from "./styles";

export const TextGradient = () => css`
  background: ${Colors.blueGreenGradient};
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
`;
